// react
import React, {useEffect, useState} from 'react'
import {Drawer} from 'antd'
import {langs} from '@uiw/codemirror-extensions-langs'
import CodeMirror from '@uiw/react-codemirror'

interface IProps {
  id?: string
  json: string
  close: () => void
}

/**
 * 流程日志详情
 * @constructor
 */
const FlowLogDetail = (props: IProps) => {

  const [Open, setOpen] = useState<boolean>(true)
  const [JsonStr, setJsonStr] = useState<string>()

  useEffect(() => {
    props.json && setJsonStr(
      JSON.stringify(JSON.parse(props.json), null, 2)
    )
  }, [props.json])

  /**
   * 关闭
   */
  const close = () => {
    setOpen(false)
    const _timeOut = setTimeout(() => {
      props.close()
      clearTimeout(_timeOut)
    }, 500)
  }

  return (
    <Drawer
      open={Open}
      onClose={() => close()}
      destroyOnClose
      width={"70%"}
      title={`流程日志详情-${props.id || ''}`}
    >
      <CodeMirror
        style={{
          border: '1px solid #d9d9d9',
          position: 'relative',
          zIndex: 20
        }}
        height="calc(100vh - 120px)"
        readOnly={true}
        value={JsonStr}
        extensions={[langs.json()]}
      />
    </Drawer>
  )
}

export default FlowLogDetail
